/**
 * Format Pix key based on explicitly selected type.
 * User picks the type first, then we apply the mask.
 */

export const PIX_TYPES = [
  { value: "cpf", label: "CPF", ph: "000.000.000-00" },
  { value: "cnpj", label: "CNPJ", ph: "00.000.000/0000-00" },
  { value: "phone", label: "Telefone", ph: "+55 31 98342-2113" },
  { value: "email", label: "E-mail", ph: "voce@exemplo.com" },
  { value: "random", label: "Chave aleatória", ph: "550e8400-e29b-..." },
];

export function formatByType(type, raw) {
  const s = raw || "";
  if (type === "email") return s.toLowerCase().replace(/\s+/g, "");
  if (type === "random") return s.trim();
  const d = s.replace(/\D/g, "");
  if (type === "cpf") {
    return d.slice(0, 11)
      .replace(/^(\d{3})(\d)/, "$1.$2")
      .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/\.(\d{3})(\d{1,2})$/, ".$1-$2");
  }
  if (type === "cnpj") {
    const t = d.slice(0, 14);
    if (t.length <= 2) return t;
    if (t.length <= 5) return `${t.slice(0, 2)}.${t.slice(2)}`;
    if (t.length <= 8) return `${t.slice(0, 2)}.${t.slice(2, 5)}.${t.slice(5)}`;
    if (t.length <= 12) return `${t.slice(0, 2)}.${t.slice(2, 5)}.${t.slice(5, 8)}/${t.slice(8)}`;
    return `${t.slice(0, 2)}.${t.slice(2, 5)}.${t.slice(5, 8)}/${t.slice(8, 12)}-${t.slice(12)}`;
  }
  if (type === "phone") {
    // BR phone: +55 DDD 9XXXX-XXXX (11 dig) or DDD XXXX-XXXX (10 dig)
    const t = d.slice(0, 13);
    let cc = "";
    let rest = t;
    if (t.length > 11) { cc = "+" + t.slice(0, t.length - 11) + " "; rest = t.slice(-11); }
    else if (t.length === 11) { cc = "+55 "; }
    if (rest.length <= 2) return `${cc}${rest}`;
    if (rest.length <= 7) return `${cc}${rest.slice(0, 2)} ${rest.slice(2)}`;
    if (rest.length === 11)
      return `${cc}${rest.slice(0, 2)} ${rest.slice(2, 7)}-${rest.slice(7)}`;
    return `${cc}${rest.slice(0, 2)} ${rest.slice(2, 6)}-${rest.slice(6)}`;
  }
  return s;
}
